<div class="list-search">
  <form>
    <mat-form-field>
      <input
        #searchInput
        matInput
        spellcheck="false"
        autocomplete="off"
        [placeholder]="TranslationKeys.FilterTypeSearch | translate"
        [formControl]="searchControl"
        (blur)="searchInput.focus()"
      />
      @if (searchControl?.value?.length) {
        <i matSuffix (click)="onRemoveSearch()" [nimbusIcon]="ICONS.CLOSE_LIGHT"></i>
      }
    </mat-form-field>
  </form>
</div>

@if (options$ | async; as availableOptions) {
  <div class="list">
    @if (selection?.length || availableOptions?.length) {
      <button nimbusPrimaryNoBorderButton class="nimbus-filter-control-button-select-all" (click)="toggleSelection()">
        <nimbus-input-check-box [checked]="hasSelection"></nimbus-input-check-box>
        <span class="selection-control-name">{{
          (hasSelection ? TranslationKeys.FilterClearSelection : TranslationKeys.FilterSelectAll) | translate
        }}</span>
      </button>
    }
    @if (nullOption) {
      <button nimbusPrimaryNoBorderButton class="nimbus-filter-control-button-select-empty" (click)="toggleNullSelection()">
        <nimbus-input-check-box [checked]="hasNullSelection"></nimbus-input-check-box>
        <span class="selection-control-name">{{ TranslationKeys.GeneralEmpty | translate }}</span>
      </button>
    }
    @if (selection?.length) {
      <div class="selection-list">
        @if (selection?.length !== optionsInternalLength) {
          @for (selectedOption of selection; track trackByFn($index, selectedOption)) {
            <nimbus-nimbus-filter-select-list-item
              [selected]="selectedOptionsLookup.has(selectedOption.id)"
              (filterSelect)="onFilterSelect($event)"
              [option]="selectedOption"
            ></nimbus-nimbus-filter-select-list-item>
          }
          <hr />
        }
      </div>
    }
    <div class="available-list">
      @if (!availableOptions?.length) {
        <span class="no-records-filter">{{ TranslationKeys.GeneralGridNoRecords | translate }}</span>
      }
      @for (option of availableOptions; track trackByFn($index, option)) {
        <nimbus-nimbus-filter-select-list-item
          [selected]="selectedOptionsLookup.has(option.id)"
          (filterSelect)="onFilterSelect($event)"
          [option]="option"
        ></nimbus-nimbus-filter-select-list-item>
      }
    </div>
  </div>
}
